export const SET_CONFIRMATION_MODAL = 'src/store/confirmation/SET_CONFIRMATION_VALUE';
export const SET_INIT_VALUE_CONFIRMATION_MODAL =
  'src/store/confirmation/SET_INIT_VALUE_CONFIRMATION_MODAL';
